import { createAction, props } from '@ngrx/store';
import { ShapeDataFeature } from '../../../zones/models/shape-data-feature';


export const drawPolygon = createAction('[Zones] Draw Polygon');
export const drawCircle = createAction('[Zones] Draw Circle');
export const drawClear = createAction('[Zones] Draw Clear');
export const highlightedZone = createAction('[Zones] Highlighted Zone', props<{data: any}>());
export const zoneVisibility = createAction('[Zones] Zone Visibility', props<{data: {zoneId: number, visibility: boolean}[]}>());
export const zoneDraw = createAction('[Zones] Zone Draw', props<{features: any}>());
export const shapeDataUpdate = createAction('[Zones] Shape Data Update', props<{data: any}>());
export const selectZone = createAction('[Zones] Select Zone', props<{zoneId: number}>());
export const selectRegion = createAction('[Zones] Select Region', props<{zoneId: number}>());
export const addRegionFeature = createAction('[Zones] Add Region Feature', props<{feature: ShapeDataFeature}>());
export const deleteRegionFeature = createAction('[Zones] Delete Region Feature', props<{regionCode: string}>());
export const clearRegionFeature = createAction('[Zones] Clear Region Feature');

export type ZonesActionsUnion = ReturnType<
  typeof drawPolygon |
  typeof drawCircle |
  typeof drawClear |
  typeof highlightedZone |
  typeof zoneVisibility |
  typeof zoneDraw |
  typeof shapeDataUpdate |
  typeof selectZone |
  typeof selectRegion |
  typeof addRegionFeature |
  typeof deleteRegionFeature |
  typeof clearRegionFeature
  >;
